import { Deserializable } from '../protocols/deserializable';
import { RemittanceStatusPill } from '../shared/remittance-status-pill';
import { RemittanceStatus } from './remittance-status';
import { RemittancePaymentStatus } from './remittance-payment-status';
import { RemittancePaymentStatusPill } from '../shared/remittance-payment-status-pill';
import { RemittanceType } from './remittance-type';
import { RemittanceSource } from './remittance-source';
import { Contribution } from './contribution';
import { RemittanceOwner } from './remittance-owner';
import { PortalType } from '../enum/shared/portal-type';
import { RemittanceStatusIdEnum } from '../enum/remittance-status-id.enum';
import { RemittanceTransaction } from '../transactions/remittance-transaction';

export class Remittance implements Deserializable {
  public id!: number;
  public employerId!: number;
  public typeId!: number;
  public statusId!: number;
  public paymentStatusId!: number;
  public sourceId!: number;
  public ownerId!: number;
  public owner: RemittanceOwner | null = null;
  public submittedDate!: string | null;
  public payPeriodEndDate!: string | null;
  public lastStatusUpdateDate!: string;
  public lastUpdatedDate!: string;
  public taxationYear!: string | null;
  public totalRemittanceAmount!: number;
  public contributionCount!: number;
  public contributionEntryCount!: number;
  public type!: RemittanceType;
  public status!: RemittanceStatus;
  public paymentStatus!: RemittancePaymentStatus;
  public source!: RemittanceSource;
  public employerName!: string;
  public contributions: Contribution[] = [];
  public transactions: RemittanceTransaction[] = [];

  // not from API
  public statusPill: RemittanceStatusPill | undefined;
  public paymentStatusPill: RemittancePaymentStatusPill | undefined;

  public isEditable(portal: PortalType): boolean {
    if (portal === PortalType.Internal) {
      return ['Submitted', 'In Review', 'Pending', 'Needs Attention'].includes(this.status?.name);
    } else if (portal === PortalType.Employer) {
      return ['Pending', 'In Review'].includes(this.status?.name);
    } else {
      return false;
    }
  }

  public isProcessing(): boolean {
    return this.status.id !== RemittanceStatusIdEnum.Pending;
  }

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(RemittanceStatus, this.status);
    }
    if (!!this.paymentStatus) {
      this.paymentStatus = Deserialize?.instanceOf(RemittancePaymentStatus, this.paymentStatus);
    }
    this.statusPill = new RemittanceStatusPill(this.status.id, this.status.name);
    this.paymentStatusPill = new RemittancePaymentStatusPill(this.paymentStatus.id, this.paymentStatus.name);
    if (!!this.source) {
      this.source = Deserialize?.instanceOf(RemittanceSource, this.source);
    }
    if (!!this.type) {
      this.type = Deserialize?.instanceOf(RemittanceType, this.type);
    }
    this.contributions = Deserialize?.arrayOf(Contribution, this.contributions);

    if (!!this.owner) {
      this.owner = Deserialize?.instanceOf(RemittanceOwner, this.owner);
    }
    if (!!this.transactions) {
      this.transactions = Deserialize?.arrayOf(RemittanceTransaction, this.transactions);
    }
  }
}
